import Vue from 'vue'
import axios from 'axios'
import {getToken, setToken, removeToken, getGwsToken, getChannel, setChannel, removeChannel} from '@/utils/auth';
import API from '@/api/index';
import Utils from '@/utils/utils';
import {Message} from "element-ui";
import Bus from '../bus/bus'
import router from "@/router";
Vue.prototype.$bus = Bus
Vue.prototype.$axios = axios
Vue.prototype.$API = API;
Vue.prototype.$utils = Utils;
Vue.prototype.$getToken = getToken;
Vue.prototype.$setToken = setToken;
Vue.prototype.$removeToken = removeToken;
// Vue.prototype.$getChannel = getChannel;
// Vue.prototype.$setChannel = setChannel;
// Vue.prototype.$removeChannel = removeChannel;
/**
 * 预览文件，图片、txt、pdf,(word、excel、ppt返回的地址不能预览)
 * @param fileObj
 * {}
 * isAsync true异步加载，false同步加载
 */
Vue.prototype.prototypePreviewFile = function (fileObj, isAsync = false, isZip = false) {
    fileObj = fileObj || {};
    let url = '';
    let xml = new XMLHttpRequest();

    // let fcn = isZip ? '/fileServer/image/thumbnail/download' : '/fileServer/download';
    // let param = isZip ? {
    //   fileId: fileObj.fileId,
    //   version: 1
    // } : fileObj;
    let fcn = `/doc/api/file/preview?fileId=${fileObj.fileId}`
    const xmlFn = (encryToken = null, timestamp = null) => {
        xml.open('GET', process.env.VUE_APP_API_ROOT + fcn, isAsync);//同步请求
        xml.setRequestHeader('Content-type', "application/json");
        xml.setRequestHeader('Authorization', getToken() ? `Bearer ${getToken()}` : '')
        // if (isShare) {
        //     xml.setRequestHeader('encryToken', encryToken);
        //     xml.setRequestHeader('timestamp', timestamp)
        //     xml.setRequestHeader('system', 'share');
        // }
        xml.send();
    }

    if (isAsync) {
        return new Promise(async (resolve, reject) => {
            xml.addEventListener('error', function (e) {
                console.log(e);
                reject('error');
            })
            xmlFn()
            // if (isShare) {
            //     let {encryToken, timestamp} = await utils.cryptoToken({url: process.env.VUE_APP_FILESERVER_ROOT + fcn});
            //     xmlFn(encryToken, timestamp)
            // } else {
            //     xmlFn()
            // }
            xml.onload = function (event) {
                if (xml.status === 200) {
                    let result = xml.responseText;//响应结果
                    // url = JSON.parse(result).data;
                    url = JSON.parse(result).data?.previewFileUrl || '';
                    resolve(url);
                } else {
                    reject('获取图片地址失败');
                    console.warn(xml)
                }
            }
        })
    } else {
        xmlFn()
        let result = xml.responseText;//响应结果
        url = JSON.parse(result).data?.previewFileUrl || '';
        return url;
    }
}
/**
 * @imgSrcList: 图片列表（如果isId为true，则为id列表）
 * @currentIndex: 当前查看
 * @isId: 传入是否为id列表
 * @isLoadAsync: 此参数针对isId:true,如果传入的图片较多，建议启用，加快查看图片的速度
 * **/
import imageViewer from "@/components/common/imageViewer.vue";
import {FILE_preview} from "@/utils/dict/File";
import Mine from "@/api/modules/mine";

Vue.prototype.$previewImage = (imgSrcList, currentIndex, isId, isLoadAsync) => {
    if (!imgSrcList || !imgSrcList.length) return;
    let imgList = imgSrcList;
    currentIndex = currentIndex || 0;
    if (isId) {
        if (isLoadAsync) {
            imgList[currentIndex] = Vue.prototype.prototypePreviewFile({
                fileId: imgSrcList[currentIndex],
                type: 'project'
            });
        } else {
            imgList = imgSrcList.map(e => Vue.prototype.prototypePreviewFile({fileId: e, type: 'project'}));
        }
    }
    const ImgViewerInstance = Vue.extend({
        render(h) {
            return this.imgViewerShow ? h(imageViewer, {
                ref: 'imageViewer',
                props: {
                    zIndex: 4000,
                    currentIndex: this.currentIndex,
                    urlList: this.imgSrcList,
                    onClose: this.closeImgViewer,
                },
            }) : null;
        },
        data() {
            return {
                imgViewerShow: true,
                currentIndex: currentIndex || 0,
                imgSrcList: imgList,
            }
        },
        methods: {
            closeImgViewer() {
                this.imgViewerShow = false;
                this.imgSrcList = [];
            },
        }
    });
    const imgViewer = new ImgViewerInstance().$mount();
    document.body.appendChild(imgViewer.$el);
}

/**
 * 统一预览文件方法，图片当前页面预览、其他可预览文件跳转到图模空间预览
 * @param row 当前点击行
 * @param cb 预览文件回调
 * @param fileList 当前文件list
 */
Vue.prototype.$handlePreviewFile = (row, cb, fileList) => {
    row.id = row.id || row.fileId
    row.dirFileName = row.dirFileName || row.fileName
    const fileName = row.dirFileName
    if (!fileName) return
    //先判断是否支持预览
    const fileExt = Utils.getFileExtension(fileName)
    // 进入图模空间
    if (!FILE_preview.includes(fileExt)) {
        cb && cb('notSupported', row)
        return
    }
    if (row.convertStatus === 1) {
        Message.info('当前文件正在转换中，请稍候查看')
        return
    } else if (row.convertStatus === 3) {
        if (typeof cb === 'function') {
            cb && cb('failure', row)
        } else {
            Message.info('当前文件转换失败，请下载查看')
        }
        return
    }
    //区别是否是图模实验室
    const isLaboratory = router.history.current.name === 'laboratory'
    //图片预览
    const source = isLaboratory ? 'laboratory' : 'file'
    if (Utils.checkFileIsPhoto(fileName)) {
        //添加浏览记录
        if(!isLaboratory){
            Mine.addFileBrowse({fileId: row.id, source})
        }
        //获取当前文件夹下图片（searchAll true 代表查询当前层级全部，false代表分页查询,暂时不传）
        const imgFileList = fileList.filter(row => {
            return (!row.isFolder && Utils.checkFileIsPhoto(row.dirFileName))
        })
        if (imgFileList.length) {
            const imgList = imgFileList.map(file => file.id);
            const currentIndex = imgFileList.findIndex(file => file.id === row.id) > -1 ? imgFileList.findIndex(file => file.id === row.id) : 0
            Vue.prototype.$previewImage(imgList, currentIndex, true, false);
        }
        //其他可预览文件跳转到图模空间预览
    } else {
        const openFn = () => {
            let url = process.env.VUE_APP_API_SPACE + '?token=' + getToken() + '&bzipId=' + row.id;
            if (row.originType) {
                url += `&originType=${row.originType}`
            }
            window.open(url, '_blank')
        }

        Mine.addFileBrowse({fileId: row.id, source}).then(res => {
        }).catch(error => {
            console.error(error.message)
        }).finally(() => {
            openFn()
        })

    }
}
